import { render, staticRenderFns } from "./PatrolStatistic.vue?vue&type=template&id=84468d54&"
import script from "./PatrolStatistic.vue?vue&type=script&lang=js&"
export * from "./PatrolStatistic.vue?vue&type=script&lang=js&"
import style0 from "./PatrolStatistic.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports